import React, { useState, useEffect, Suspense } from "react";
import HeaderNoLogin from "./header/HeaderNoLogin";
import HeaderLogin from "./header/HeaderLogin";
import Navigator from "./header/Navigator";
import Home from "./pages/Home.js";
import Casino from "./pages/Casino.js";
import CustomPage from "./pages/CustomPage.js";
import Profile from "./pages/Profile.js";
import SportContent from "./pages/Sport.js"; // Import SportContent component
import Footer from "./footer/footer.js";
import NavigationBarBottom from "./footer/navigation_bar_bottom.js";
import AuthService from "../../class/services/AuthService";
import UserService from "../../class/User/UserService";
import UserServices from "../../class/User_copy/UserService";
import Cookies from "js-cookie";
import ModalGame from "./modal/modal_game.js";
import ResetPage from "./pages/ResetPage.js";
import Game from "../../class/Game/Game.js";
import Games from "../../class/Game_copy/Game.js";

import MultiPage from "../Desktop/pages/comm/multible_bonus_bet_table.js";

import ModalRegister from "./modal/modal_register.js";
import ModalLogin from "./modal/modal_login.js";
import { useTranslation } from "react-i18next";

const DesktopComponent = ({
    def_lang,
    isLogged,
    setIsLogged,
    forceMobile,
    setForceMobile,
}) => {
    const { t } = useTranslation();

    const [userId, setUserId] = useState(null);
    const [activePage, setActivePage] = useState("home");
    const [selection, setSelection] = useState("");
    const [urlname, seturlname] = useState("home");

    const [isInternal, setisInternal] = useState(false);

    const [lang, setLang] = useState(def_lang);

    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showRegisterModal, setShowRegisterModal] = useState(false);

    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    const handleCloseModal = (modalType) => {
        setIsAnimating(true);
        setTimeout(() => {
            setIsLoginModalOpen(false);
            setIsAnimating(false);
        }, 300);
    };

    const openLoginModal = () => {
        setShowRegisterModal(false);
        setShowLoginModal(true);
    };

    const closeLoginModal = () => {
        setShowLoginModal(false);
    };

    const openRegisterModal = () => {
        setShowLoginModal(false);
        setShowRegisterModal(true);
    };

    const closeRegisterModal = () => {
        setShowRegisterModal(false);
    };

    const [page_id, setPage_id] = useState(0);
    const [selection_header_external, setselection_header_external] =
        useState("profile");
    const [page_short_link, setpage_short_link] = useState([
        "home",
        "profile",
        "casino",
        "casino-live",
        "virtual",
        "bingo",
        "crash-game",
        "sport",
        "live",
        "account_setting",
        "cash_movement",
        /* 'deposit_withdraw', 'notification', */ "bet_history",
        "bonus_table" /* , 'promotions' */,
    ]);
    const [page_short_link_internal, set_page_short_link_internal] = useState([
        "Sport_Rules",
        "Casino_FAQ",
        "AML_KYC",
        "Fairness_RNG",
        "Responsible_Gaming",
        "Privacy_Policy",
        "Terms_Conditions",
        "About_us",
        "Contact",
    ]);
    const profilePages = [
        "profile",
        "account_setting",
        "bet_history",
        "cash_movement" /* , 'deposit_withdraw' */ /* , 'notification' */ /* , 'promotions' */,
    ];

    const [triggerLinkLogin, setTriggerLinkLogin] = useState(false);

    useEffect(() => {
        const checkLoginStatus = () => {
            const loggedIn = AuthService.isLogged();
            setIsLogged(loggedIn);
            if (loggedIn) {
                setUserId(AuthService.getCustom("user_id"));
            }

            if (Cookies.get("lang")) {
                setLang(Cookies.get("lang"));
            }
        };

        const GET_URL_NAME = () => {
            let fullUrl = window.location.href;
            if (fullUrl.includes("#")) {
                fullUrl = fullUrl.split("#")[0];
            }

            const pathname = new URL(fullUrl).pathname;
            const urlName = fullUrl.substring(fullUrl.lastIndexOf("/") + 1);

            if (pathname.startsWith("/register")) {
                const queryParameters = new URLSearchParams(
                    window.location.search
                );
                const promoter_code = queryParameters.get("promoter_code");

                AuthService.setCustom("promoter_code", promoter_code);
                setShowRegisterModal(true); // Set the modal state here without causing infinite loops
            }

            const queryParameters7 = new URLSearchParams(
                window.location.search
            );
            const user_hash = queryParameters7.get("userhash");

            if (user_hash) {
                AuthService.setCustom("user_hash", user_hash);
                setIsLoginModalOpen(true);
                setTriggerLinkLogin(true);
            }

            if (pathname.startsWith("/reset")) {
                setActivePage("reset");
                seturlname("reset");
                return;
            }

            if (!isLogged && profilePages.includes(urlName)) {
                setActivePage("home");
                seturlname("home");
                return;
            }

            // Додано логіку для перенаправлення bet_history
            if (urlName === "bet_history") {
                seturlname("profile");
                setActivePage("profile");
                setselection_header_external("bet_history");
                return;
            }

            if (profilePages.includes(urlName)) {
                seturlname("profile");
                setActivePage("profile");
                setselection_header_external(urlName);
                return;
            }

            if (page_short_link.includes(urlName)) {
                setActivePage(urlName);
                seturlname(urlName);
                return;
            }

            if (page_short_link_internal.includes(urlName)) {
                setisInternal(true);
                setActivePage(urlName);
                seturlname(urlName);
                setPage_id(
                    `https://cloud.gsplattform.com/infopage/amatic365/${lang}/${urlName.toLowerCase()}.php`,
                );
                return;
            }
        };

        checkLoginStatus();
        GET_URL_NAME();
    }, [isLogged, lang]);

    const changeLink = (urlname) => {
        // Оновлюємо URL без перезавантаження сторінки
        window.history.pushState({}, "", urlname);
    };

    const handleNavigationChange = (
        page,
        selection,
        isInternal = false,
        external_url = "",
    ) => {
        if (
            casinoSections.hasOwnProperty(page) &&
            casinoSections[page] === true
        ) {
            alert("Access to this section is restricted.");
            return;
        } else console.warn(`Access to ${page} section is allowed.`);

        if (page === "casino-live" && casinoSections.casino_live === true) {
            alert("Access to this section is restricted.");
            return;
        }

        if (["sport", "live"].includes(page) && casinoSections.sport === true) {
            alert("Access to this section is restricted.");
            return;
        }

        if (page === "profile" && selection === "bet_history") {
            setselection_header_external("bet_history"); // Додано
            setActivePage("profile");
            return;
        }
        if (external_url) {
            setisInternal(true);
            setActivePage(page);
            setSelection(selection);
            seturlname(page);
            setPage_id(external_url);
            changeLink(`/${page}`);
        } else if (page_short_link.includes(page)) {
            seturlname(page);
            changeLink(`/${page}`);
            setSelection(selection);
            setisInternal(false);
            setActivePage(page);
        } else if (page_short_link_internal.includes(page)) {
            setisInternal(true);
        } else {
            seturlname(page);
            changeLink(`/${page}`);
            setisInternal(false);
            setPage_id(selection);
            setActivePage(page);
        }
    };

    const [homeReload, setHomeReload] = useState(false);

    useEffect(() => {
        if (homeReload === true) {
            setHomeReload(false); // resetta subito

            window.location.href = "/";
            //window.location.reload();
        }
    }, [homeReload]);

    const [isUserCashBlocked, setIsUserCashBlocked] = useState(() => {
        return AuthService.getCustom("user_cash_block") || false;
    });

    const [casinoSections, setCasinoSections] = useState({}); // { sectionTag: true/false, ... }
    const [withdrawSection, setDepositWithdrawSection] = useState(true);

    useEffect(() => {
        const fetchCasinoSections = async () => {
            console.warn(
                `Fetching casino sections for userId: ${userId}, isLogged: ${isLogged}`,
            );

            if (isLogged && userId) {
                try {
                    // non chiede piu l enabled, ma verifica se sono attivi provider per la categoria, se no la toglie
                    const result = await UserServices.getAvailableArea(userId);
                    if (
                        result.status == "ok" &&
                        result.params &&
                        Object.keys(result.params).length > 0
                    ) {
                        const sections = {
                            casino: true,
                            casino_live: true,
                            poker: true,
                            bingo: true,
                            virtual: true,
                            sport: true,
                            crash_games: true,
                            live: true,
                            "casino-live": true,
                            "crash-game": true,
                        };

                        Object.keys(result.params).forEach((key) => {
                            const shopValue = result.params[key];
                            sections[key] = shopValue === 0; // false = visibile, true = nascosto

                            if (key == "casino_live") {
                                sections["casino-live"] = sections[key];
                            }
                            if (key == "casino-live") {
                                sections["casino_live"] = sections[key];
                            }
                            if (key == "crash_games") {
                                sections["crash-game"] = sections[key];
                            }
                            if (key == "crash-game") {
                                sections["crash_games"] = sections[key];
                            }
                            if (key == "sport") {
                                sections["live"] = sections[key];
                            }
                            if (key == "live") {
                                sections["sport"] = sections[key];
                            }
                        });

                        const sport_auth = await Games.authSportbook(userId);
                        console.warn(
                            "Transformed casino sections:",
                            sport_auth,
                        );

                        if (sport_auth.status == "ok") {
                            sections["live"] = !sport_auth.params;
                            sections["sport"] = !sport_auth.params;
                        }

                        console.warn("Transformed casino sections:", sections);

                        setCasinoSections(sections);
                        setDepositWithdrawSection(true);
                    } else
                        console.warn(
                            "Failed to fetch casino sections:",
                            result.status,
                        );
                } catch (e) {
                    setCasinoSections({});
                    setDepositWithdrawSection(true);

                    console.error("Error fetching casino sections:", e);
                }
            } else {
                console.warn(`All sections activated`);
                setCasinoSections({
                    casino: false,
                    casino_live: false,
                    poker: false,
                    bingo: false,
                    virtual: false,
                    sport: false,
                    crash_games: false,
                    live: false,
                    "casino-live": false,
                    "crash-game": false,
                });
                setDepositWithdrawSection(false);
            }

            // console.warn(`All sections activated`);
            // setCasinoSections({"casino" : false, "casino_live" : false, "poker" : false, "bingo" : false, "virtual" : false, "sport" : false, "crash_games" : false, "live" : false, "casino-live" : false, "crash-game" : false});
            // setDepositWithdrawSection(true);  // blocked for the skin
        };

        fetchCasinoSections();
    }, [isLogged, userId]);

    return (
        <div className="desktop-view">
            {isLogged ? (
                <HeaderLogin
                    handleNavigationChange={handleNavigationChange}
                    setselection_header_external={setselection_header_external}
                    selection_header_external={selection_header_external}
                    user_id={userId}
                    setLang={setLang}
                    forceMobile={forceMobile}
                    setForceMobile={setForceMobile}
                    casinoSections={casinoSections}
                    setIsUserCashBlocked={setIsUserCashBlocked}
                    withdrawSection={withdrawSection}
                />
            ) : (
                <HeaderNoLogin
                    setIsLogged={setIsLogged}
                    setUserId={setUserId}
                    showRegisterModal={showRegisterModal}
                    forceMobile={forceMobile}
                    setForceMobile={setForceMobile}
                    casinoSections={casinoSections}
                    setIsUserCashBlocked={setIsUserCashBlocked}
                    setHomeReload={setHomeReload}
                />
            )}
            <Navigator
                handleNavigationChange={handleNavigationChange}
                activePage={activePage}
                casinoSections={casinoSections}
                isLogged={isLogged}
                AuthService={AuthService}
                UserService={UserServices}
                setIsLoginModalOpen={setIsLoginModalOpen}
            />
            {activePage === "home" && (
                <Home
                    showLoginModal={showLoginModal}
                    openLoginModal={openLoginModal}
                    closeLoginModal={closeLoginModal}
                    lang={lang}
                    handleOpenRegisterModal={openRegisterModal}
                    isLogged={isLogged}
                    setIsLogged={setIsLogged}
                    category={activePage}
                    casinoSections={casinoSections}
                    isUserCashBlocked={isUserCashBlocked}
                    setIsUserCashBlocked={setIsUserCashBlocked}
                    setHomeReload={setHomeReload}
                    setIsLoginModalOpen={setIsLoginModalOpen}
                />
            )}
            {activePage === "profile" && (
                <Profile
                    selection={selection}
                    selection_header_external={selection_header_external}
                    setselection_header_external={setselection_header_external}
                    withdrawSection={withdrawSection}
                />
            )}
            {activePage === "casino" && (
                <Casino
                    handleOpenRegisterModal={openRegisterModal}
                    lang={lang}
                    isLogged={isLogged}
                    activePage={activePage}
                    setIsLogged={setIsLogged}
                    onNavigationChange={handleNavigationChange}
                    AuthService={AuthService}
                    UserService={UserServices}
                    category={activePage}
                    casinoSections={casinoSections}
                    setIsLoginModalOpen={setIsLoginModalOpen}
                />
            )}
            {activePage === "casino-live" && (
                <Casino
                    handleOpenRegisterModal={openRegisterModal}
                    lang={lang}
                    isLogged={isLogged}
                    activePage={activePage}
                    setIsLogged={setIsLogged}
                    onNavigationChange={handleNavigationChange}
                    AuthService={AuthService}
                    UserService={UserServices}
                    category={activePage}
                    casinoSections={casinoSections}
                    setIsLoginModalOpen={setIsLoginModalOpen}
                />
            )}
            {activePage === "virtual" && (
                <Casino
                    handleOpenRegisterModal={openRegisterModal}
                    lang={lang}
                    isLogged={isLogged}
                    activePage={activePage}
                    setIsLogged={setIsLogged}
                    onNavigationChange={handleNavigationChange}
                    AuthService={AuthService}
                    UserService={UserServices}
                    category={activePage}
                    casinoSections={casinoSections}
                    setIsLoginModalOpen={setIsLoginModalOpen}
                />
            )}
            {activePage === "bingo" && (
                <Casino
                    handleOpenRegisterModal={openRegisterModal}
                    lang={lang}
                    isLogged={isLogged}
                    activePage={activePage}
                    setIsLogged={setIsLogged}
                    onNavigationChange={handleNavigationChange}
                    AuthService={AuthService}
                    UserService={UserServices}
                    category={activePage}
                    casinoSections={casinoSections}
                    setIsLoginModalOpen={setIsLoginModalOpen}
                />
            )}
            {activePage === "crash-game" && (
                <Casino
                    handleOpenRegisterModal={openRegisterModal}
                    lang={lang}
                    isLogged={isLogged}
                    activePage={activePage}
                    setIsLogged={setIsLogged}
                    onNavigationChange={handleNavigationChange}
                    AuthService={AuthService}
                    UserService={UserServices}
                    category={selection || activePage}
                    casinoSections={casinoSections}
                    setIsLoginModalOpen={setIsLoginModalOpen}
                />
            )}
            {(activePage === "sport" || activePage === "live") && (
                <SportContent
                    isLogged={isLogged}
                    selection={activePage}
                    lang={AuthService.getCustom("lang")}
                    casinoSections={casinoSections}
                />
            )}{" "}
            {/* Pass the iframe URL */}
            {activePage === "reset" && (
                <ResetPage UserService={UserServices} />
            )}{" "}
            {/* Pass the iframe URL */}
            {activePage === "bonus_table" && <MultiPage />}
            {/* Custom Page Render */}
            {!page_short_link.includes(activePage) && (
                <CustomPage
                    isLogged={isLogged}
                    setIsLogged={setIsLogged}
                    AuthService={AuthService}
                    UserService={UserServices}
                    page_id={page_id}
                    isInternal={isInternal}
                />
            )}
            <Footer
                isLogged={isLogged}
                onNavigationChange={handleNavigationChange}
                activePage={activePage}
                lang={lang}
                setLang={setLang}
                casinoSections={casinoSections}
            />
            <ModalRegister
                show={showRegisterModal}
                onClose={closeRegisterModal}
                onOpenLoginModal={openLoginModal}
            />
            {isLoginModalOpen && (
                <Suspense fallback={<div>{t("loading")}...</div>}>
                    <ModalLogin
                        setIsLogged={setIsLogged}
                        show={isLoginModalOpen && !isAnimating}
                        onClose={handleCloseModal}
                        isUserCashBlocked={isUserCashBlocked}
                        setIsUserCashBlocked={setIsUserCashBlocked}
                        setHomeReload={setHomeReload}
                        onOpenRegisterModal={() => {
                            handleCloseModal();
                            setTimeout(() => openRegisterModal(), 300);
                        }}
                        triggerLinkLogin={triggerLinkLogin}
                        setTriggerLinkLogin={setTriggerLinkLogin}
                    />
                </Suspense>
            )}
            <ModalGame
                isLogged={isLogged}
                setIsLogged={setIsLogged}
                openRegisterModal={openRegisterModal}
                isUserCashBlocked={isUserCashBlocked}
                setIsUserCashBlocked={setIsUserCashBlocked}
                setHomeReload={setHomeReload}
            />
        </div>
    );
};

export default DesktopComponent;
